module.exports = __webpack_public_path__ + "img/Nino Gordeladze.d3f27a65.png";